import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import ToggleButtonElement from '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import styles from './IntrusionVolume.module.scss.js';

function IntrusionVolume(_ref) {
  var onChange = _ref.onChange,
    isToggled = _ref.isToggled,
    error = _ref.error;
  var _useState = useState(isToggled),
    _useState2 = _slicedToArray(_useState, 2),
    lowVolume = _useState2[0],
    setLowVolume = _useState2[1];
  useEffect(function () {
    setLowVolume(isToggled);
  }, [isToggled]);
  var toggleSetLowVolume = function toggleSetLowVolume() {
    setLowVolume(!lowVolume);
    onChange(!lowVolume);
  };
  var currentVolume = lowVolume ? t('MPLIB_SIREN_INTRUSION_LOWER_VOLUME') : t('MPLIB_SIREN_INTRUSION_NORMAL_VOLUME');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleButtonElement, {
    dataTestId: "settings-item-intusion-volume",
    onClick: toggleSetLowVolume,
    isChecked: lowVolume,
    text: t('MPLIB_SIREN_INTRUSION_VOLUME_TITLE'),
    subText: t('MPLIB_SIREN_INTRUSION_VOLUME_DESC'),
    className: classNames(styles.noborder, styles.minContent)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.active
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "secondary"
  }, " ", t('MPLIB_SIREN_INTRUSION_ACTIVE_VOLUME'), ": "), currentVolume), /*#__PURE__*/React.createElement("div", {
    className: styles.error
  }, error && error.description)));
}
IntrusionVolume.propTypes = {
  onChange: PropTypes.func.isRequired,
  isToggled: PropTypes.bool,
  error: PropTypes.shape({
    description: PropTypes.string
  })
};
IntrusionVolume.defaultProps = {
  isToggled: false,
  error: null
};

export { IntrusionVolume as default };
